
import React, { useState, useEffect, useContext } from "react";
import "./Blog.scss"; // Optional: for styling
import { Fade } from "react-reveal";
import StyleContext from "../../contexts/StyleContext";


export default function Blog() {
  const { isDark } = useContext(StyleContext);
  const [blogs, setBlogs] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      const response = await fetch("/api/blog.php");
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      console.log("data"+data);
     
      setBlogs(data);
    } catch (error) {
      setError("Database connection issue. Check log."+error);
      console.error("Error fetching blogs:", error);
    }
  };

  if (error) {
    return (
      <div id="blog">
        <Fade bottom duration={1000} distance="20px">
          <div className="blog-container">
            <h1 className="blog-heading">Blog</h1>
            <p>{error}</p>
          </div>
        </Fade>
      </div>
    );
  }

  if (blogs.length > 0) {
    return (
      <div id="blog" className={
        isDark
          ? "dark-mode contact-subtitle"
          : "subTitle contact-subtitle"
      }> 
        <Fade bottom duration={1000} distance="20px">
          <div className="blog-container">
            <h1 className="blog-heading">Blog</h1>
            <div className="blog-posts-div">
              {blogs.map((blog, i) => (
                <div key={i} className="blog-post">
                  <h2>{blog.title}</h2>
                  <img src={blog.image_path} alt={blog.title} />
                  <p>{blog.description}</p>
                </div>
              ))}
            </div>
          </div>
        </Fade>
      </div>
    );
  }

  return null;
}